/**
 * Drop the last path segment from a URL pathname.
 *
 *   /lab-insights/parameters/abc → /lab-insights/parameters
 *   /lab-insights/parameters     → /lab-insights
 *   /lab-insights                → /
 *   /                            → /
 *
 * Used by back-button handlers that should follow the URL hierarchy. Routes
 * for the popped paths must exist (or redirect) for navigation to succeed.
 */
export const popPathSegment = (pathname: string): string => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length <= 1) return "/";
  return "/" + segments.slice(0, -1).join("/");
};
